/* Product page: picture slider + colour/option selection + WhatsApp and appointment links. */
(function () {
  var root = document.querySelector('[data-slider]'); if (!root) return;
  var track = root.querySelector('.pslider__track'), slides = track.children;
  var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
  var dots = root.querySelectorAll('[data-dot]');
  function index() { return Math.round(track.scrollLeft / track.clientWidth); }
  function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
  function sync() {
    var i = index();
    dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
  }
  if (prev) prev.addEventListener('click', function () { go(index() - 1); });
  if (next) next.addEventListener('click', function () { go(index() + 1); });
  dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
  track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
  track.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
  });
  window.addEventListener('resize', function () { go(index()); });
  sync();

  /* appointment pop-up */
  var dlg = document.getElementById('apptDialog');
  var body = dlg && dlg.querySelector('input[name="contact[body]"]');
  function openDlg() { if (!dlg) return; if (dlg.showModal) { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', ''); }
  function closeDlg() { if (!dlg) return; if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  if (dlg) {
    document.querySelectorAll('[data-open-appt]').forEach(function (b) { b.addEventListener('click', openDlg); });
    dlg.querySelectorAll('[data-close-appt]').forEach(function (b) { b.addEventListener('click', closeDlg); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDlg(); });
    if (dlg.querySelector('[data-show]')) openDlg();
  }

  /* options (colour, size ...) */
  var box = document.querySelector('[data-options]');
  var jsonEl = document.getElementById('variants-json');
  var wa = document.querySelector('[data-wa]');
  if (!box || !jsonEl) return;
  var variants = JSON.parse(jsonEl.textContent), sets = box.querySelectorAll('.opt');
  function update(scroll) {
    var sel = [], parts = [];
    sets.forEach(function (fs) {
      var c = fs.querySelector('input:checked'); if (!c) return;
      sel.push(c.value); parts.push(fs.getAttribute('data-name') + ': ' + c.value);
      fs.querySelector('[data-label]').textContent = c.value;
    });
    var v = variants.filter(function (x) { return x.o.every(function (o, i) { return o === sel[i]; }); })[0];
    if (v && scroll && v.p > 0) go(v.p - 1);
    var url = location.origin + location.pathname + (v ? '?variant=' + v.id : '');
    if (v) history.replaceState(null, '', '?variant=' + v.id);
    var opts = parts.join(', ');
    var t = (wa && wa.getAttribute('data-title')) || (dlg && dlg.getAttribute('data-title')) || '';
    if (wa) wa.href = 'https://wa.me/' + wa.getAttribute('data-number') + '?text=' + encodeURIComponent(wa.getAttribute('data-msg') + ' ' + t + (opts ? ' (' + opts + ')' : '') + '\n' + url);
    if (body) body.value = 'Appointment request for: ' + t + (opts ? ' (' + opts + ')' : '') + ' - ' + url;
  }
  box.addEventListener('change', function () { update(true); });
  update(false);
})();
